export const formatMoney = (
  amount: number | null,
  currency?: string,
  options?: { signed?: boolean },
): string => {
  const rawAmount = amount || 0
  const formattedAmount = options?.signed ? rawAmount : Math.abs(rawAmount)

  return formattedAmount.toLocaleString('en-US', {
    currency: currency || 'USD',
    maximumFractionDigits: 0,
    style: 'currency',
  })
}
